import clsx from 'clsx';
import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useEventCallback } from '@eas/common-web';
import { DashboardCard } from '../card';
import { useStyles } from '../dashboard';
import { DashboardSearchContext } from './search-dashboard-context';

export function Search() {
  const classes = useStyles();

  const { searchText, setSearchText, handleSearch } = useContext(
    DashboardSearchContext
  );

  const handleSearchTextChange = useEventCallback((e) => {
    setSearchText(e.target.value);
  });

  const handleKeyDown = useEventCallback((e) => {
    if (e.key === 'Enter' && searchText) {
      e.preventDefault();
      handleSearch();
    }
  });

  return (
    <Grid item xs={12} className={classes.wrapper}>
      <Typography
        variant="subtitle1"
        className={clsx(classes.padded, classes.subtitle)}
      >
        Vyhledávání
      </Typography>

      <div style={{ maxWidth: '700px' }}>
        <DashboardCard title="Rychlé vyhledání spisu, dokumentu, rozhodnutí dle spisové značky (čísla jednacího), čárového kódu, navrhovatele/pisatele, vedlejšího účastníka, právního zástupce.">
          <Paper className={classes.input} elevation={0}>
            <InputBase
              placeholder="Začněte psát"
              fullWidth={true}
              value={searchText}
              onChange={handleSearchTextChange}
              onKeyDown={handleKeyDown}
              autoFocus={true}
            />
            <Button
              variant="contained"
              color="primary"
              disableElevation
              className={classes.search}
              disabled={!searchText}
              onClick={handleSearch}
            >
              Hledej
            </Button>
          </Paper>
        </DashboardCard>
      </div>
    </Grid>
  );
}
